import { render, staticRenderFns } from "./Delete-Request-Template.vue?vue&type=template&id=1c8657d3&"
import script from "./Delete-Request-Template.vue?vue&type=script&lang=js&"
export * from "./Delete-Request-Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports